import { render, staticRenderFns } from "./LiveStockWidget.vue?vue&type=template&id=63c8f670"
import script from "./LiveStockWidget.vue?vue&type=script&lang=js"
export * from "./LiveStockWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports